import { render, staticRenderFns } from "./KeyboardAdaptationWrapper.vue?vue&type=template&id=6db4c035&scoped=true&"
import script from "./KeyboardAdaptationWrapper.vue?vue&type=script&lang=js&"
export * from "./KeyboardAdaptationWrapper.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6db4c035",
  null
  
)

export default component.exports